import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
//components
import Container from "../../../components/container/container";
import NavBarUser from "../../../components/navigation/NavBarUser";
import GuestOrderSummary from "./GuestOrderSummary";
import { SelectShipperModal } from "../../../components/modals/selectShipperModal";
import { AddCouponModal } from "../../../components/modals/addCouponModal";
import { AddGuestAddressModal } from "../../../components/modals/address/addGuestAddressModal";
import { AddGuestContactModal } from "../../../components/modals/address/addGuestContactModal";
//icons
import Coupon from "../../../assets/images/icons/coupon.svg";
import Timer from "../../../assets/images/icons/timer.svg";
import Delivery from "../../../assets/images/icons/Delivery.svg";
import Location from "../../../assets/images/icons/Location.svg";
import ChevronRight from "../../../assets/images/icons/chevron-right.svg";
import Profile from "../../../assets/images/icons/profile.svg";
import { numberWithCommas } from "../../../components/helpers";
import {
  showMyCart,
  showMyCartNoProperties,
} from "../../../redux/cart/cartAction";
import { getMyAddressesAction } from "../../../redux/address/addressActions";
import { isAuthenticatedUser } from "../../../utils/Auth";
import { filterPublicServiceAreas } from "../../../redux/publicServiceAreas/publicServiceAreasActions";
import { getLocalStorageJSON } from "../../../helpers/getLocalStorageJSON";

export default function CartGuestCheckout() {
  const dispatch = useDispatch();
  const isAuth = isAuthenticatedUser();
  const [searchParams] = useSearchParams();
  const shipperIdFromUrl = searchParams.get("shipperId");
  const deliveryModeIdFromUrl = searchParams.get("deliveryModeId");
  const localCart = getLocalStorageJSON("ogwugo-cart");

  const { cartProducts, myCarts } = useSelector((state) => state.cart);
  const { setShipper } = useSelector((state) => state.publicShippers);

  const [myCart, setMyCart] = useState([]);
  const [currentShipper, setCurrentShipper] = useState({});
  const [isOpenShipperModal, setIsOpenShipperModal] = useState(false);
  const [isOpenAddressModal, setIsOpenAddressModal] = useState(false);
  const [isOpenCouponModal, setIsOpenCouponModal] = useState(false);
  const [isOpenContactModal, setIsOpenContactModal] = useState(false);
  
  const finalShipperId = shipperIdFromUrl || setShipper?.id;
  const finalDeliveryModeId =
    deliveryModeIdFromUrl || setShipper?.delivery_mode_id;
  const [payLoad] = useState({
    end_date: new Date(),
    pagination: 0,
    shipper_id: finalShipperId,
  });
  const [isContinueClicked, setIsContinueClicked] = useState(false);

  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    latitude: "",
    longitude: "",
    zip: "",
    products: [],
    packages: [],
    service_area_id: "",
    checkout_codes: [],
    description: "",
    shipper_id: finalShipperId,
    delivery_mode_id: finalDeliveryModeId,
  });

  // Initialize currentShipper from setShipper on mount
  useEffect(() => {
    if (setShipper && setShipper?.id) {
      setCurrentShipper({
        ...setShipper,
        delivery_mode: setShipper.delivery_modes?.find(
          (mode) => mode.id === finalDeliveryModeId
        ),
        delivery_mode_id: finalDeliveryModeId,
      });
    }
    // eslint-disable-next-line
  }, [setShipper, finalDeliveryModeId]);

  useEffect(() => {
    if (typeof window !== "undefined" && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (payLoad.shipper_id) {
      dispatch(filterPublicServiceAreas(payLoad));
    }
    // eslint-disable-next-line
  }, [finalShipperId]);

  useEffect(() => {
    if (isAuth) {
      dispatch(getMyAddressesAction());
      dispatch(showMyCart());
      dispatch(showMyCartNoProperties());
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    cartProducts && setMyCart(cartProducts?.data);
    if (cartProducts) {
      let value =
        cartProducts?.data?.coupons?.[0]?.coupon_slug ||
        cartProducts?.data?.promotion_codes?.[0]?.promotion_code_slug;
      setData({
        ...data,
        products: cartProducts?.data?.products,
        packages: cartProducts?.data?.packages,
        checkout_codes:
          cartProducts?.data?.coupons?.length > 0 ||
          cartProducts?.data?.promotion_codes?.length > 0
            ? [{ checkout_code_slug: value }]
            : [],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartProducts]);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setData({ ...data, [name]: value });
    if (name === "address" || name === "service_area_id") {
      setIsContinueClicked(false);
    }
  };

  function getCartTotal() {
    if (isAuth && (myCart?.products || myCart?.packages)) {
      let product_no = myCart?.products ? Number(myCart?.products?.length) : 0;
      let package_no = myCart?.packages ? Number(myCart?.packages?.length) : 0;
      return product_no + package_no;
    } else {
      if (localCart?.products || localCart?.packages) {
        let product_local = localCart?.products
          ? Number(localCart?.products?.length)
          : 0;
        let package_local = localCart?.packages
          ? Number(localCart?.packages?.length)
          : 0;
        return product_local + package_local;
      } else {
        return 0;
      }
    }
  }

  const cartTotal = getCartTotal();

  return (
    <div data-test="cartComponent">
      <NavBarUser />
      <div className="shadow-md mb-6 sm:mb-16">
        <Container>
          <div className="py-4 sm:pt-12 sm:pb-6">
            <h2
              className="text-[#333333] dark:text-white text-3xl sm:text-5xl font-bold mb-0 sm:mb-4"
              style={{ lineHeight: "64px" }}
            >
              Guest Checkout
            </h2>
            <p className="text-lg text-gray-400 dark:text-[#BCBCBC] -mt-1 sm:mt-0">
              {cartTotal} Item
              {cartTotal > 1 ? "s" : ""} in the cart
            </p>
          </div>
        </Container>
      </div>

      <Container>
        <main className="pb-8">
          <div className="max-w-3xl mx-auto lg:max-w-7xl">
            <div className="grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-16">
              {/* Left column */}
              <div className="grid grid-cols-1 gap-4 lg:col-span-2 max-w-[610px]">
                <section aria-labelledby="section-1-title">
                  <h2 className="sr-only" id="section-1-title">
                    Checkout Details
                  </h2>

                  {/* 1. Delivery Details */}
                  <div className="sm:max-w-3xl mb-4">
                    <h3 className="text-2xl font-medium mb-2">
                      1. Delivery Details
                    </h3>
                    <p className="dark:text-[#BCBCBC]">
                      Make sure your delivery details are correct.
                    </p>
                  </div>

                  <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mb-12 shadow-[0px_18px_40px_0px_#7090B01F]">
                    {/* Contact Information */}
                    <div 
                      className="flex justify-between my-1 py-2 border-b border-[#EEEEEE]"
                      data-testid="contact-information-section"
                    >
                      <div className="flex gap-2">
                        <img
                          src={Profile}
                          alt="icon"
                          className="mr-2 w-[32px] h-auto"
                        />
                        <div>
                          <p className="text-[#344B67] dark:text-white">
                            Contact Information
                          </p>
                          {data?.name && data?.email && data?.phone ? (
                            <div className="text-sm mt-1">
                              <p>{data?.name}</p>
                              <p className="text-gray-500">{data?.email}</p>
                              <p className="text-gray-500">{data?.phone}</p>
                            </div>
                          ) : (
                            <p className="text-gray-500 text-sm">
                              Click 'Add' to enter your contact details
                            </p>
                          )}
                        </div>
                      </div>

                      <button
                        type="button"
                        className="flex items-center gap-1"
                        onClick={() => setIsOpenContactModal(true)}
                        aria-label="add-contact-information"
                      >
                        <span className="text-primary-500 text-sm">
                          {data?.name && data?.email && data?.phone
                            ? "Change"
                            : "Add"}
                        </span>
                        <img
                          src={ChevronRight}
                          alt="icon"
                          className="w-[16px] h-auto"
                        />
                      </button>
                    </div>

                    {/* Current address/change */}
                    <div 
                      className="flex justify-between my-1 py-2 border-b border-[#EEEEEE]"
                      data-testid="delivery-address-section"
                    >
                      <div className="flex gap-2">
                        <img
                          src={Location}
                          alt="icon"
                          className="mr-2 w-[32px] h-auto"
                        />
                        <div>
                          <p className="text-[#344B67] dark:text-white">
                            Deliver To
                          </p>
                          {data?.address ? (
                            <p className="text-sm">
                              {data?.address}, {data?.city}, {data?.state},{" "}
                              {data?.country}
                            </p>
                          ) : (
                            <p className="text-gray-500 text-sm">
                              Click 'Add' to enter your delivery address
                            </p>
                          )}
                        </div>
                      </div>

                      <button
                        type="button"
                        className="flex items-center gap-1"
                        onClick={() => setIsOpenAddressModal(true)}
                        aria-label="add-delivery-address"
                      >
                        <span className="text-primary-500 text-sm">
                          {data?.address ? "Change" : "Add"}
                        </span>
                        <img
                          src={ChevronRight}
                          alt="icon"
                          className="w-[16px] h-auto"
                        />
                      </button>
                    </div>

                    {/* current shipper/change */}
                    <div className="flex justify-between my-1 py-2 border-b border-[#EEEEEE]">
                      <div className="flex gap-2">
                        <img
                          src={Delivery}
                          alt="icon"
                          className="mr-2 w-[32px] h-auto"
                        />
                        <div>
                          <p className="text-[#344B67] dark:text-white">
                            Delivery Partner
                          </p>
                          {currentShipper && currentShipper?.name ? (
                            <div>
                              <p className="text-sm capitalize">
                                {currentShipper?.name}
                              </p>
                              {currentShipper?.delivery_mode && (
                                <p className="text-xs text-gray-500 dark:text-gray-400 capitalize">
                                  {currentShipper?.delivery_mode?.title}
                                  {currentShipper?.delivery_mode?.pivot
                                    ?.charge > 0 && (
                                    <span className="ml-1">
                                      (+ ₦
                                      {numberWithCommas(
                                        currentShipper?.delivery_mode?.pivot
                                          ?.charge
                                      )}
                                      )
                                    </span>
                                  )}
                                </p>
                              )}
                            </div>
                          ) : (
                            <p className="text-sm">
                              You have not set any shipper
                            </p>
                          )}
                        </div>
                      </div>

                      <button
                        type="button"
                        className="flex items-center gap-1"
                        onClick={() => setIsOpenShipperModal(true)}
                      >
                        <span className="text-primary-500 text-sm">Change</span>
                        <img
                          src={ChevronRight}
                          alt="icon"
                          className="w-[16px] h-auto"
                        />
                      </button>
                    </div>

                    {/* estimated delivery */}
                    <div className="flex mb-4 justify-between items-center py-2">
                      <div className="flex gap-2">
                        <img
                          src={Timer}
                          alt="icon"
                          className="mr-2 w-[32px] h-auto"
                        />
                        <div>
                          <p className="text-[#344B67] dark:text-white">
                            Estimated Delivery
                          </p>
                          <p className="text-sm">30-40 mins</p>
                        </div>
                      </div>
                      <div className="h-fit bg-[#D1FED8] px-3 py-1 rounded-lg">
                        <span className="text-[#115E1D] text-sm font-medium">
                          On Time
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* 2. Order Summary */}
                  <div className="sm:max-w-3xl mb-4">
                    <h3 className="text-2xl font-medium mb-2">
                      2. Order Summary
                    </h3>
                    <p className="dark:text-[#BCBCBC]">
                      Review your selected items here:
                    </p>
                  </div>

                  {/* Cart Product list */}
                  {myCart?.products?.length > 0 || myCart?.packages?.length > 0 ? (
                    <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mb-12 shadow-[0px_18px_40px_0px_#7090B01F]">
                      <h3 className="text-xl font-medium mb-6 pb-3 border-b">
                        Cart Items
                      </h3>

                      {/* Products */}
                      {myCart?.products?.length > 0 &&
                        myCart.products.map((product, i) => (
                          <div key={i + product.id}>
                            <div className="flex justify-between items-start mb-5">
                              <div className="flex">
                                <span className="w-6 mr-10">{product.quantity}X</span>
                                <div>
                                  <p className="mb-2 capitalize">
                                    {product?.food_name || product?.merchandise_name}
                                  </p>
                                  {product?.attributes?.length > 0 &&
                                    product?.attributes?.map((attr, i) => (
                                      <p key={i + attr?.name} className="text-sm capitalize">
                                        {attr.quantity}x {attr?.name}
                                      </p>
                                    ))}
                                  <p className="text-xs text-gray-500 mt-1">
                                    {product?.product_outlet_name}
                                  </p>
                                </div>
                              </div>
                              <div className="flex gap-4">
                                <p>
                                  ₦
                                  {numberWithCommas(
                                    (product?.food_amount || product?.merchandise_amount) *
                                      product.quantity
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}

                      {/* Packages */}
                      {myCart?.packages?.length > 0 &&
                        myCart.packages.map((pkg, i) => (
                          <div key={i + pkg.id}>
                            <div className="flex justify-between items-start mb-5">
                              <div className="flex">
                                <span className="w-6 mr-10">{pkg.quantity}X</span>
                                <div>
                                  <p className="mb-2 capitalize">{pkg?.package_name}</p>
                                  <p className="text-xs text-gray-500 mt-1">
                                    Package
                                  </p>
                                </div>
                              </div>
                              <div className="flex gap-4">
                                <p>
                                  ₦{numberWithCommas(pkg?.package_amount * pkg.quantity)}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mb-12 shadow-[0px_18px_40px_0px_#7090B01F]">
                      <div className="text-center py-8">
                        <p className="text-gray-500 dark:text-gray-400 mb-2">
                          Your cart is empty
                        </p>
                        <p className="text-sm text-gray-400 dark:text-gray-500">
                          Add items to your cart to proceed with checkout
                        </p>
                      </div>
                    </div>
                  )}

                  {/* 3. Additional Options */}
                  <div className="mb-4">
                    <h3 className="text-2xl font-medium mb-2">
                      3. Additional Options (Optional)
                    </h3>
                    <p className="dark:text-[#BCBCBC]">
                      Add a coupon or delivery instruction
                    </p>
                  </div>

                  <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mb-12 shadow-[0px_18px_40px_0px_#7090B01F]">
                    {/* Coupon Code */}
                    <div className="flex justify-between my-1 py-2 border-b border-[#EEEEEE]">
                      <div className="flex gap-2">
                        <img
                          src={Coupon}
                          alt="icon"
                          className="mr-2 w-[32px] h-auto dark:hidden"
                        />
                        <div>
                          <p className="text-[#344B67] dark:text-white">
                            Coupon Code
                          </p>
                          <p className="text-gray-500 text-sm">
                            {myCart?.coupons?.[0]?.coupon_slug ||
                              myCart?.promotion_codes?.[0]
                                ?.promotion_code_slug ||
                              "No coupon applied"}
                          </p>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="flex items-center gap-1"
                        onClick={() => setIsOpenCouponModal(true)}
                      >
                        <span className="text-primary-500 text-sm">
                          {myCart?.coupons?.[0]?.coupon_slug ||
                          myCart?.promotion_codes?.[0]?.promotion_code_slug
                            ? "Edit"
                            : "Add Code"}
                        </span>
                        <img
                          src={ChevronRight}
                          alt="icon"
                          className="w-[16px] h-auto"
                        />
                      </button>
                    </div>
                  </div>
                </section>
              </div>

              {/* Right column - Pricing Summary */}
              <div className="lg:col-span-1">
                <GuestOrderSummary
                  myCart={myCart}
                  setMyCart={setMyCart}
                  orderData={data}
                  isContinueClicked={isContinueClicked}
                  setIsContinueClicked={setIsContinueClicked}
                  currentShipper={currentShipper}
                  onOpenShipperModal={() => setIsOpenShipperModal(true)}
                  onOpenAddressModal={() => setIsOpenAddressModal(true)}
                  onOpenContactModal={() => setIsOpenContactModal(true)}
                />
              </div>
            </div>
          </div>
        </main>
      </Container>

      {/* Modals */}
      <SelectShipperModal
        show={isOpenShipperModal}
        onClose={() => {
          setIsOpenShipperModal(false);
          setIsContinueClicked(false);
        }}
        setCurrentShipper={(shipper) => {
          setCurrentShipper(shipper);
          setData((prev) => ({
            ...prev,
            shipper_id: shipper?.id,
            delivery_mode_id: shipper?.delivery_mode_id || "",
          }));
        }}
        currentShipper={currentShipper}
      />
      <AddCouponModal
        show={isOpenCouponModal}
        onClose={() => setIsOpenCouponModal(false)}
        myCart={myCart}
        myCarts={myCarts}
        currentShipper={currentShipper}
      />
      <AddGuestAddressModal
        show={isOpenAddressModal}
        setIsOpen={setIsOpenAddressModal}
        onClose={() => setIsOpenAddressModal(false)}
        handleChange={handleChange}
        data={data}
        setData={setData}
        setIsContinueClicked={setIsContinueClicked}
      />
      <AddGuestContactModal
        show={isOpenContactModal}
        onClose={() => setIsOpenContactModal(false)}
        handleChange={handleChange}
        data={data}
      />
    </div>
  );
}
